import styled from 'styled-components';

export const Icon = styled.i`
  font-size: 0.75rem !important;
  position: absolute;
  margin-left: 4.75rem;
  padding-top: 0.25rem;
  color: var(--green);
`;
